(function () {

  // ── Sort select ─────────────────────────────────────────────────────────────

  var sel = document.getElementById('lcg-sort-select');
  if (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ── Filter accordion ─────────────────────────────────────────────────────────

  document.querySelectorAll('.coll-filter-group__trigger').forEach(function (btn) {
    if (btn.closest('[data-mo-filter]')) return;
    btn.addEventListener('click', function () {
      btn.closest('.coll-filter-group').classList.toggle('coll-filter-group--open');
    });
  });

  // ── Mobile drawer ─────────────────────────────────────────────────────────────

  var overlay = document.getElementById('lcg-drawer-overlay');
  var drawer  = document.getElementById('lcg-drawer');

  function openDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.add('coll-drawer-overlay--open');
    drawer.classList.add('coll-drawer--open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.remove('coll-drawer-overlay--open');
    drawer.classList.remove('coll-drawer--open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-lcg-open-drawer]').forEach(function (el) {
    el.addEventListener('click', openDrawer);
  });

  document.querySelectorAll('[data-lcg-close-drawer]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

})();

// ── Podcast card: play first episode + sticky player ─────────────────────────
(function () {
  var currentAudio      = null;
  var currentBtn        = null;
  var SAMPLE_SEC        = 30;
  var SAMPLE_START_SEC  = 240; // skip past intros/ads — start 4 min in

  var sp        = document.getElementById('lpc-sticky-player');
  var spPlayBtn = document.getElementById('lpc-sp-playpause');
  var spSkipBack= document.getElementById('lpc-sp-skip-back');
  var spSkipFwd = document.getElementById('lpc-sp-skip-fwd');
  var spClose   = document.getElementById('lpc-sp-close');
  var spSeek    = sp && sp.querySelector('.lpc-sp__seek');
  var spPos     = sp && sp.querySelector('.lpc-sp__pos');
  var spDur     = sp && sp.querySelector('.lpc-sp__dur');
  var spTitle   = sp && sp.querySelector('.lpc-sp__title');
  var spEp      = sp && sp.querySelector('.lpc-sp__ep');
  var spCover   = sp && sp.querySelector('.lpc-sp__cover');
  var spIcoPlay = spPlayBtn && spPlayBtn.querySelector('.lpc-sp__ico--play');
  var spIcoPause= spPlayBtn && spPlayBtn.querySelector('.lpc-sp__ico--pause');
  var spIcoLoad = spPlayBtn && spPlayBtn.querySelector('.lpc-sp__ico--loading');

  function fmtTime(sec) {
    if (!isFinite(sec) || sec < 0) return '0:00';
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function showStickyPlayer(podcastTitle, epTitle, coverSrc) {
    if (!sp) return;
    if (spTitle) spTitle.textContent = podcastTitle || '';
    if (spEp)    spEp.textContent    = epTitle      || '';
    if (spCover) { spCover.src = coverSrc || ''; spCover.alt = podcastTitle || ''; }
    sp.hidden = false;
    requestAnimationFrame(function () { sp.classList.add('lpc-sp--visible'); });
  }

  function hideStickyPlayer() {
    if (!sp) return;
    sp.classList.remove('lpc-sp--visible');
    setTimeout(function () { if (!sp.classList.contains('lpc-sp--visible')) sp.hidden = true; }, 400);
  }

  function setStickyState(state) {
    if (!spIcoPlay) return;
    spIcoPlay.hidden  = state !== 'paused';
    spIcoPause.hidden = state !== 'playing';
    spIcoLoad.hidden  = state !== 'loading';
    if (spPlayBtn) spPlayBtn.setAttribute('aria-label', state === 'playing' ? 'Pause' : state === 'loading' ? 'Loading' : 'Play');
  }

  function setBtn(btn, state) {
    var playIcon  = btn.querySelector('.lpc-play-icon');
    var pauseIcon = btn.querySelector('.lpc-pause-icon');
    btn.classList.remove('is-playing', 'is-loading');
    btn.disabled = false;
    if (playIcon)  { playIcon.hidden  = false; playIcon.style.display  = ''; }
    if (pauseIcon) { pauseIcon.hidden = true;  pauseIcon.style.display = ''; }
    if (state === 'playing') {
      btn.classList.add('is-playing');
      if (playIcon)  playIcon.hidden = true;
      if (pauseIcon) pauseIcon.hidden = false;
    } else if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }
  }

  function stopCurrent() {
    if (currentAudio) { currentAudio.pause(); currentAudio.src = ''; currentAudio = null; }
    if (currentBtn)   { setBtn(currentBtn, 'play'); currentBtn = null; }
    hideStickyPlayer();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lindie-product-card__play-overlay, .lac-card__play-overlay, .lindie-podcast-card__play-overlay');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var rssUrl   = btn.dataset.epRss;
    var proxyUrl = (window.__lindieStore || {}).rssFeedProxy;

    if (!rssUrl) {
      console.warn('[LINDIE] Play button missing data-ep-rss');
      return;
    }
    if (!proxyUrl) {
      console.warn('[LINDIE] window.__lindieStore.rssFeedProxy not set — check shop metafield lindie.rss_proxy_url');
      return;
    }

    if (currentBtn === btn && currentAudio && !currentAudio.paused) {
      currentAudio.pause();
      return;
    }
    if (currentBtn === btn && currentAudio && currentAudio.paused) {
      currentAudio.play().then(function () { setBtn(btn, 'playing'); setStickyState('playing'); });
      return;
    }

    stopCurrent();

    var card         = btn.closest('.lindie-podcast-card');
    var coverImg     = card && card.querySelector('.lindie-podcast-card__image');
    var coverSrc     = coverImg ? (coverImg.getAttribute('src') || '') : '';
    var titleEl      = card && card.querySelector('.lindie-podcast-card__title');
    var podcastTitle = titleEl ? titleEl.textContent.trim() : '';

    currentBtn = btn;
    setBtn(btn, 'loading');

    fetch(proxyUrl + '?url=' + encodeURIComponent(rssUrl))
      .then(function (r) {
        if (!r.ok) throw new Error('RSS fetch ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var firstItem = json && json.items && json.items[0];
        var audioUrl  = firstItem && firstItem.enclosure && firstItem.enclosure.link;
        var epTitle   = (firstItem && firstItem.title) || 'Episode 1';
        if (!audioUrl) throw new Error('No audio enclosure in RSS feed');

        var audio = new Audio(audioUrl);
        currentAudio = audio;

        showStickyPlayer(podcastTitle, epTitle, coverSrc);
        setStickyState('loading');

        // Seek to start offset once we know the duration
        audio.addEventListener('loadedmetadata', function () {
          if (currentAudio !== audio) return;
          var start = audio.duration > SAMPLE_START_SEC + SAMPLE_SEC
            ? SAMPLE_START_SEC
            : Math.max(0, audio.duration - SAMPLE_SEC - 5);
          audio.currentTime = start;
        });

        audio.addEventListener('timeupdate', function () {
          var startSec = audio.currentTime < SAMPLE_START_SEC ? 0 : SAMPLE_START_SEC;
          var endSec   = startSec + SAMPLE_SEC;
          if (audio.currentTime >= endSec) {
            if (currentAudio === audio) stopCurrent();
            return;
          }
          var elapsed = Math.max(0, audio.currentTime - startSec);
          if (spPos) spPos.textContent = fmtTime(elapsed);
          if (spDur) spDur.textContent = fmtTime(SAMPLE_SEC);
          if (spSeek) spSeek.value = (elapsed / SAMPLE_SEC) * 100;
        });

        audio.addEventListener('play',  function () {
          if (currentBtn === btn) { setBtn(btn, 'playing'); setStickyState('playing'); }
        });
        audio.addEventListener('pause', function () {
          if (currentBtn === btn) { setBtn(btn, 'play'); setStickyState('paused'); }
        });
        audio.addEventListener('ended', function () {
          if (currentBtn === btn) stopCurrent();
        });
        audio.addEventListener('error', function () {
          console.warn('[LINDIE] Audio error', audio.error);
          if (currentBtn === btn) stopCurrent();
        });

        return audio.play().then(function () {
          setBtn(btn, 'playing');
          setStickyState('playing');
        });
      })
      .catch(function (err) {
        console.warn('[LINDIE] Podcast play failed:', err);
        if (currentBtn === btn) { setBtn(btn, 'play'); currentBtn = null; currentAudio = null; }
        hideStickyPlayer();
      });
  }, true);

  if (spPlayBtn) {
    spPlayBtn.addEventListener('click', function () {
      if (!currentAudio) return;
      if (currentAudio.paused) {
        currentAudio.play().then(function () { setStickyState('playing'); if (currentBtn) setBtn(currentBtn, 'playing'); });
      } else {
        currentAudio.pause();
      }
    });
  }

  if (spSkipBack) {
    spSkipBack.addEventListener('click', function () {
      if (!currentAudio) return;
      var s = currentAudio.currentTime < SAMPLE_START_SEC ? 0 : SAMPLE_START_SEC;
      currentAudio.currentTime = Math.max(s, currentAudio.currentTime - 15);
    });
  }

  if (spSkipFwd) {
    spSkipFwd.addEventListener('click', function () {
      if (!currentAudio) return;
      var s = currentAudio.currentTime < SAMPLE_START_SEC ? 0 : SAMPLE_START_SEC;
      currentAudio.currentTime = Math.min(s + SAMPLE_SEC, currentAudio.currentTime + 30);
    });
  }

  if (spSeek) {
    spSeek.addEventListener('input', function () {
      if (!currentAudio) return;
      var s = currentAudio.currentTime < SAMPLE_START_SEC ? 0 : SAMPLE_START_SEC;
      currentAudio.currentTime = s + (spSeek.value / 100) * SAMPLE_SEC;
    });
  }

  if (spClose) {
    spClose.addEventListener('click', stopCurrent);
  }

})();

